export const routePersistingFields = ['subtitle', 'title'];
